<template>
    <div>
        <div class="loginpanel">
            <div class="loginpanelinner">
                
                <div class="logo animate0 bounceIn"><h1>Zine Orders</h1></div>
                <form id="login" @submit.prevent="login()">
                    
                    <div class="inputwrapper login-alert" v-if="error">
                        <div class="alert alert-error">Wachtwoord onjuist</div>
                    </div>
                    <div class="inputwrapper animate1 bounceIn">
                        <input @keyup="triggerSubmit($event)" type="text" name="username" id="username" placeholder="Emailadres" v-model="email" />
                    </div>
                    <div class="inputwrapper animate2 bounceIn">
                        <input @keyup="triggerSubmit($event)" type="password" name="password" id="password" placeholder="Wachtwoord" v-model="password" />
                    </div>
                    <div class="inputwrapper animate3 bounceIn">
                        <button @click="login()">Inloggen</button>
                    </div>
                    
                </form>
                
            </div><!--loginpanelinner-->
        </div><!--loginpanel-->

        <div class="loginfooter">
            
        </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'
export default {
    name:'login',
    data() {
        return {
            email : '',
            password : '',
            error : false,
        }
    },
    created(){
        window.$('body').css('background','#0866c6');
        window.$('h1').css('color','#fff');
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        })
    },
    methods : {
        triggerSubmit(e){
            if(e.which == '13'){
                this.login();
            }
        },
        login : function(){
            var data = {
                'email'     : this.email,
                'password'  : this.password,
            };
            this.$store.dispatch('login',{'endpoint' : this.endpoint+'login', 'details': data})
            .then((data)=>{
                console.log(data);
                this.error = false;
                var api_token = data.data.api_token;
                
                if(process.env.VUE_APP_TEST==1){
                    api_token = 'UqDS5pqtOcg4jUbfTIpBUcPD06yiBXIWcNyB0D95NqxCnP34DedJDDbmNS8r';
                }
                
                localStorage.setItem('api_token', api_token);
                window.location.href='/dashboard';
            })
            .catch((error)=>{
                this.error = true;
                console.log(error.request);
                var api_token = data.data.api_token;
                
                if(process.env.VUE_APP_TEST==1){
                    api_token = 'UqDS5pqtOcg4jUbfTIpBUcPD06yiBXIWcNyB0D95NqxCnP34DedJDDbmNS8r';
                    localStorage.setItem('api_token', api_token);
                    window.location.href='/dashboard';
                }else{
                    localStorage.setItem('api_token', api_token);
                }
            })
        }
    }
}
</script>

<style type="text/css" scoped>
    h1{
        color: #FFF !important;
    }
    .login-alert{
        display: block;
    }
</style>